var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"popin"}},[(_vm.isVisible)?_c('div',{staticClass:"adminNotice"},[_c('h2',[_vm._v(_vm._s(_vm.type))]),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }